import { DateUtils } from '../../../../Utils/DateUtils';
import { AuthenticationResult } from '../../../../Models/Authentication/AuthResponse';
import { addSeconds } from 'date-fns';

export class AuthUtils {
    public static getAuthorizationFromToken = (token: string) => `Bearer ${token}`;

    /**
     ** Adds an `expiration_date` as an ISO string
     * @param {Object} auth
     */
    static transformAuth = (auth: AuthenticationResult) => ({
        ...auth,
        expiration_date: addSeconds(new Date(), auth.expires_in).toISOString(),
    });

    public static authenticationIsExpired(expirationDate: any) {
        return !expirationDate || DateUtils.isDateBeforeWithParse(expirationDate, new Date());
    }

    public static toAuthWithExpirationDate = (auth: AuthenticationResult) => ({
        ...auth,
        expiration_date: addSeconds(new Date(), auth.expires_in || 0).toISOString(),
    });

    static getAuthorizationString: string;
}
